
export default 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';



// WEBPACK FOOTER //
// ./node_modules/ally.js/src/supports/media/gif.js